<div class="notification-link-comp {{displayClass}}">
    <div class="notification-item-wrapper" [ngClass]="{'has-link-path': item.isDeepLinkAvailable}" *ngIf="!isRouterLink"
        (click)="onLinkClick(item)"
        (keydown)="onLinkClick(item)">
        <p [ngClass]="['notification-title', item.isRead?'read':'unread']">{{item.title}}</p>
        <div class="date-and-time">
            <p class="notification-subtext">{{formatNotificationDate(item.startDate)}}</p> <span
                class="pipe-seperator"></span>
            <p class="notification-subtext">{{formatNotificationTime(item.startDate)}}</p>
            <!-- <p class="notification-subtext">{{item.startDate | date: 'h:mm a' | lowercase}}</p> -->
        </div>
    </div>
    <hr />
</div>